import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from './../../IconButton/IconButton';
import MoreVertical from '@ellucian/ds-icons/lib/MoreVertical';
import Tooltip from './../../Tooltip/Tooltip';
/**
 * Icon button component for Action menu
 */

var ActionMenuIconButton = function ActionMenuIconButton(props) {
  var id = props.id,
      edsContext = props.edsContext,
      icon = props.icon,
      IconButtonProps = props.IconButtonProps,
      open = props.open,
      setOpen = props.setOpen,
      buttonRef = props.buttonRef;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: edsContext.formatMessage('component.ActionMenu.more'),
    enterDelay: 1000,
    enterNextDelay: 1000
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    ref: buttonRef,
    disableRipple: true,
    "aria-label": edsContext.formatMessage('component.ActionMenu.more'),
    "aria-expanded": open,
    "aria-haspopup": "true",
    "aria-controls": id,
    onClick: setOpen,
    color: "gray",
    tabIndex: 0
  }, IconButtonProps), icon));
};

ActionMenuIconButton.propTypes = {
  buttonRef: PropTypes.object,
  open: PropTypes.bool,
  setOpen: PropTypes.func,

  /**
   * @ignore
   */
  edsContext: PropTypes.object,
  icon: PropTypes.node,

  /**
   * Menu HTML ID for uniqueness.
   */
  id: PropTypes.string,

  /**
   * Props applied to the IconButton that brings up the action menu
  */
  IconButtonProps: PropTypes.object,

  /**
   * @ignore
   *
   * Externally set the initial open state of the action menu. For testing purposes only.
   */
  initialOpenOverride: PropTypes.bool
};
ActionMenuIconButton.defaultProps = {
  icon: /*#__PURE__*/React.createElement(MoreVertical, null)
};
export default ActionMenuIconButton;